// extracted by mini-css-extract-plugin
export default {"dots":"HamburgerMenuIcon_dots__-MZPL","dot":"HamburgerMenuIcon_dot__LvfjP"};